import styled from 'styled-components';
import { border, layout, padding, margin, color, space, typography } from 'styled-system';
import { GeneralInputStyleProps, defaultInputStyleProps } from './GeneralInputStyles';
import { FC } from 'react';
import { RegisterOptions } from 'react-hook-form';
import { VStack } from '@bpba/ui-components';
import { GenericInputError } from './GenericInputError';
import { InputProps } from './InputProps';
import { INPUT_OBLIGATORY_MESSAGE } from '../../../constants/form';
import { useInputAriaErrors } from './useInputAriaErrors';

export const SELECT_DEFAULT_VALUE = '-1';

export type Option = {
  title: string;
  value: string | number;
};

type Props = {
  options: Option[];
  isNumber?: boolean;
} & InputProps &
  React.ComponentProps<typeof StyledSelect>;

export const SelectComponent: FC<Props> = (props) => {
  const { options, placeholder, name, formRegister, errorCollection, required, isNumber, mr, ...otherProps } = props;
  const validationOptions = getValidationOptions(required, isNumber);
  const validations = formRegister(name, validationOptions);
  const accesibleErrorsConfig = useInputAriaErrors(name, errorCollection, required);

  return (
    <VStack width="100%" mr={mr}>
      <StyledSelect required={required} {...accesibleErrorsConfig} {...otherProps} {...validations} defaultValue={SELECT_DEFAULT_VALUE}>
        <option value={SELECT_DEFAULT_VALUE} disabled>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.title}
          </option>
        ))}
      </StyledSelect>
      <GenericInputError fieldName={name} id={accesibleErrorsConfig['aria-describedby']} errorCollection={errorCollection} />
    </VStack>
  );
};

SelectComponent.defaultProps = {
  mr: '16px',
};

const getValidationOptions = (required?: boolean, isNumber?: boolean): RegisterOptions => {
  return {
    required: {
      value: !!required,
      message: INPUT_OBLIGATORY_MESSAGE,
    },
    setValueAs: (v) => (v === SELECT_DEFAULT_VALUE ? undefined : isNumber ? parseInt(v) : v),
  };
};

const StyledSelect = styled.select<GeneralInputStyleProps>(border, layout, padding, margin, color, space, typography, {
  ':invalid': {
    color: `${'placeholder'}`,
  },
});

StyledSelect.defaultProps = {
  ...defaultInputStyleProps,
};
